<template>
    <div>
        <h5>Stations</h5>
        <div>
            <div class="flex justify-content-end">
                <!-- <h6>Search Criteria:</h6>-->
                <div>
                    <Button v-if="authStore.hasPermission(UserPermission.WRITE_STATION)" label="Add Station" class="mb-2 mr-2" @click="dialogForm = true" />
                </div>
            </div>
            <!-- create station form -->
            <station-form v-if="dialogForm" @hide-dialog="dialogForm = false" />
            <!-- station table -->
            <station-table />
        </div>
    </div>
</template>
<script setup>
import { ref } from 'vue';
import StationTable from '../modules/StationTable.vue';
import StationForm from '../modules/StationForm.vue';
import { authStore } from '@/store/global-stores';
import { UserPermission } from '@/modules/permission/enum';



const dialogForm = ref(false);
</script>
